module.exports = __webpack_public_path__ + "img/joinus.d98068ce.jpg";